/* eslint max-len: "off" */

/**
 * @deprecated - This will be removed in version 2.0.0. Migrate to the src/messages directory using the next-intl structure.
 * Migration steps:
 * 1. Move these translations to the src/messages directory.
 * 2. Use the next-intl library to manage translations.
 * 3. Ensure all translations include Spanish (es) as a supported language.
 */
export const translations = {
  cosmeticDiagnostics: {
    en: 'cosmetic diagnostics',
    ar: 'التشخيص التجميلي',
    he: 'ניתוח קוסמטי',
    fr: 'diagnostics cosmétiques',
    ro: 'diagnosticare cosmetică',
    nl: 'cosmetische diagnostiek',
    pl: 'diagnostyka kosmetyczna',
    de: 'kosmetische diagnose',
    es: 'evaluación estética',
  },
  initiate: {
    title: {
      en: 'Initiate cosmetic assessment on customer’s trade-in device',
      ar: 'بدء التقييم التجميلي على جهاز المقايضة الخاص بالعميل',
      he: 'התחל ניתוח קוסמטי והערכת מצב המכשיר של הלקוח',
      fr: "Lancer l'évaluation cosmétique sur le dispositif de reprise du client",
      ro: 'Inițiați evaluarea cosmetică a dispozitivului de schimb al clientului',
      nl: 'Start cosmetische beoordeling van het inruilapparaat van de klant',
      pl: 'Rozpocznij ocenę kosmetyczną urządzenia klienta do wymiany',
      de: 'Kosmetische Bewertung des Eintauschgeräts des Kunden starten',
      es: 'Inicia la evaluación estética en el dispositivo del cliente para la recompra',
    },
    subTitle: {
      en: 'Please press start when ready.',
      ar: 'يرجى الضغط على ابدأ عندما تكون جاهزًا.',
      he: 'אנא לחץ התחל כאשר הינך מוכן',
      fr: 'Veuillez appuyer sur démarrer lorsque vous êtes prêt.',
      ro: 'Vă rugăm să apăsați start când sunteți gata.',
      nl: 'Druk op start wanneer u klaar bent.',
      pl: 'Proszę nacisnąć start, gdy będziesz gotowy.',
      de: 'Bitte drücken Sie Start, wenn Sie bereit sind.',
      es: 'Pulsa Comenzar cuando esté todo listo.',
    },
    start: {
      en: 'Start',
      ar: 'بدء',
      he: 'התחל',
      fr: 'Démarrer',
      ro: 'Începeți',
      nl: 'Start',
      pl: 'Start',
      de: 'Starten',
      es: 'Comenzar',
    },
    restartAssessment: {
      en: 'Restart Assessment',
      ar: 'إعادة التقييم',
      he: 'התחל מחדש הערכת מצב מכשיר',
      fr: "Redémarrer l'évaluation",
      ro: 'Reîncepeți evaluarea',
      nl: 'Beoordeling opnieuw starten',
      pl: 'Uruchom ponownie ocenę',
      de: 'Bewertung neu starten',
      es: 'Reiniciar evaluación',
    },
  },
  instructions: {
    title: {
      en: 'Upload the following images of the device',
      ar: 'قم بتحميل صور الجهاز التالية',
      he: 'העלה את תמונות המכשיר',
      fr: "Téléchargez les images suivantes de l'appareil",
      ro: 'Încărcați următoarele imagini ale dispozitivului',
      nl: 'Upload de volgende afbeeldingen van het apparaat',
      pl: 'Prześlij następujące zdjęcia urządzenia',
      de: 'Laden Sie die folgenden Bilder des Geräts hoch',
      es: 'Carga las siguientes imágenes del dispositivo',
    },
    subTitle: {
      en: 'The device should be placed against a plain background. No hands or body parts in the image.',
      ar: 'يجب وضع الجهاز على خلفية عادية. لا توجد أيدي أو أجزاء من الجسم في الصورة.',
      he: 'המכשיר צריך להיות מונח על פני רקע נקי וברור. ללא ידיים או חלקי גוף בתמונה.',
      fr: "L'appareil doit être placé contre un fond uni. Aucune main ni partie du corps dans l'image.",
      ro: 'Dispozitivul trebuie plasat pe un fundal simplu. Fără mâini sau părți ale corpului în imagine.',
      nl: 'Het apparaat moet tegen een effen achtergrond worden geplaatst. Geen handen of lichaamsdelen in de afbeelding.',
      pl: 'Urządzenie powinno być umieszczone na jednolitym tle. Bez rąk ani części ciała na zdjęciu.',
      de: 'Das Gerät sollte vor einem einfarbigen Hintergrund platziert werden. Keine Hände oder Körperteile im Bild.',
      es: 'El dispositivo debe colocarse sobre un fondo liso. No deben aparecer manos ni otras partes del cuerpo en la foto.',
    },
    captureCTA: {
      en: 'Capture image',
      ar: 'التقاط الصورة',
      he: 'צלם תמונה',
      fr: "Capturer l'image",
      ro: 'Capturează imaginea',
      nl: 'Afbeelding vastleggen',
      pl: 'Zrób zdjęcie',
      de: 'Bild aufnehmen',
      es: 'Hacer la foto',
    },
    restartAssessment: {
      en: 'Restart Assessment',
      ar: 'إعادة التقييم',
      he: 'התחל מחדש הערכת מצב מכשיר',
      fr: "Redémarrer l'évaluation",
      ro: 'Reîncepeți evaluarea',
      nl: 'Beoordeling opnieuw starten',
      pl: 'Uruchom ponownie ocenę',
      de: 'Bewertung neu starten',
      es: 'Reiniciar la evaluación',
    },
  },
  instructionsList: {
    item0: {
      en: 'The customer’s trade-in device should be placed against a plain background.',
      ar: 'يجب وضع جهاز استبدال العميل على خلفية عادية.',
      he: 'מכשיר הלקוח צריך להיות מונח על פני רקע נקי וברור.',
      fr: "L'appareil de reprise du client doit être placé contre un fond uni.",
      ro: 'Dispozitivul de schimb al clientului trebuie plasat pe un fundal simplu.',
      nl: 'Het inruilapparaat van de klant moet tegen een effen achtergrond worden geplaatst.',
      pl: 'Urządzenie klienta do wymiany powinno być umieszczone na jednolitym tle.',
      de: 'Das Eintauschgerät des Kunden sollte vor einem einfarbigen Hintergrund platziert werden.',
      es: 'El dispositivo del cliente para la recompra debe colocarse sobre un fondo liso.',
    },
    item1: {
      en: 'No hands, fingers, or body parts in the image.',
      ar: 'لا توجد أيدي أو أصابع أو أجزاء من الجسم في الصورة.',
      he: 'ללא ידיים, אצבעות, או חלקי גוף בתמונה.',
      fr: "Aucune main, doigt ou partie du corps dans l'image.",
      ro: 'Fără mâini, degete sau părți ale corpului în imagine.',
      nl: 'Geen handen, vingers of lichaamsdelen in de afbeelding.',
      pl: 'Brak rąk, palców ani części ciała na zdjęciu.',
      de: 'Keine Hände, Finger oder Körperteile im Bild.',
      es: 'No deben aparecer manos, dedos ni otras partes del cuerpo en la foto.',
    },
    item2: {
      en: "Align the device, press shutter button and capture the full image of the customer's trade-in device",
      ar: 'قم بمحاذاة الجهاز ، واضغط على زر الغالق والتقط الصورة الكاملة لجهاز استبدال العميل',
      he: 'יישר את המכשיר, לחץ על כפתור הסגירה וצלם את מכשיר הלקוח',
      fr: "Alignez l'appareil, appuyez sur le bouton de l'obturation et capturez l'image complète de l'appareil de reprise du client.",
      ro: 'Aliniați dispozitivul, apăsați butonul de declanșare și capturați imaginea completă a dispozitivului de schimb al clientului.',
      nl: 'Lijn het apparaat uit, druk op de sluiterknop en leg de volledige afbeelding van het inruilapparaat van de klant vast.',
      pl: 'Wyrównaj urządzenie, naciśnij przycisk migawki i zrób pełne zdjęcie urządzenia klienta do wymiany',
      de: 'Gerät ausrichten, Auslöser drücken und das vollständige Bild des Eintauschgeräts des Kunden aufnehmen',
      es: 'Encuadra el dispositivo y fotografía el dispositivo completo del cliente para la recompra.',
    },
  },
  done: {
    en: 'Done',
    ar: 'تقييم',
    he: 'הושלם',
    fr: 'Terminé',
    ro: 'Terminat',
    nl: 'Klaar',
    pl: 'Gotowe',
    de: 'Fertig',
    es: 'Redactado',
  },
  doneMessage: {
    en: 'Done',
    ar: 'تقييم',
    he: 'הושלם',
    fr: 'Terminé',
    ro: 'Terminat',
    nl: 'Klaar',
    pl: 'Gotowe',
    de: 'Fertig',
    es: 'Redactado',
  },
  evaluate: {
    en: 'Evaluate',
    ar: 'تقييم',
    he: 'הערך',
    fr: 'Évaluer',
    ro: 'Evaluează',
    nl: 'Evalueren',
    pl: 'Oceń',
    de: 'Bewerten',
    es: 'Evaluar',
  },
  pleaseWait: {
    en: 'Please Wait',
    ar: 'أرجو الإنتظار',
    he: 'אנא המתן',
    fr: 'Veuillez patienter',
    ro: 'Vă rugăm să așteptați',
    nl: 'Even geduld',
    pl: 'Proszę czekać',
    de: 'Bitte warten',
    es: 'Por favor espera',
  },
  evaluateDevice: {
    en: 'Evaluate Device',
    ar: 'تقييم الجهاز',
    he: 'הערך מצב מכשיר',
    fr: 'évaluerAppareil',
    ro: 'Evaluați Dispozitivul',
    nl: 'Beoordeel Apparaat',
    pl: 'Oceń urządzenie',
    de: 'Gerät Bewerten',
    es: 'Evaluar Dispositivo',
  },
  documentToUpload: {
    en: 'Documents to upload',
    ar: 'وثائق للتحميل',
    he: 'מסמכים להעלאה',
    fr: 'Documents à télécharger',
    ro: 'Documente de încărcat',
    nl: 'Documenten om te uploaden',
    pl: 'Dokumenty do przesłania',
    de: 'Hochzuladende Dokumente',
    es: 'Documentos para cargar',
  },
  uploadStatus: {
    uploadPending: {
      en: 'Pending Upload',
      ar: 'تحميل معلق',
      he: 'ממתין לסיום העלאה',
      fr: 'Téléchargement en attente',
      ro: 'Încărcare în așteptare',
      nl: 'Upload in behandeling',
      pl: 'Oczekiwanie na przesłanie',
      de: 'Ausstehender Upload',
      es: 'Carga pendiente',
    },
    uploadSuccess: {
      en: 'Uploaded',
      ar: 'تم الرفع بنجاح',
      he: 'הועלה בהצלחה',
      fr: 'Téléchargé',
      ro: 'Încărcat cu succes',
      nl: 'Geüpload',
      pl: 'Przesłano',
      de: 'Hochgeladen',
      es: 'Cargado',
    },
    uploadCompleted: {
      en: 'Uploaded',
      ar: 'تم الرفع بنجاح',
      he: 'הועלה בהצלחה',
      fr: 'Téléchargé',
      ro: 'Încărcat',
      nl: 'Geüpload',
      pl: 'Przesłano',
      de: 'Hochgeladen',
      es: 'Cargado',
    },
    uploadFailed: {
      en: 'Failed',
      ar: 'التحميل فشل',
      he: 'נכשל',
      fr: 'Échec',
      ro: 'Eșuat',
      nl: 'Mislukt',
      pl: 'Niepowodzenie',
      de: 'Fehlgeschlagen',
      es: 'Error',
    },
  },
  doneUploading: {
    title: {
      en: 'Image Upload complete',
      ar: 'اكتمل تحميل الصورة',
      he: 'העלאת תמונה הושלמה',
      fr: "Téléchargement de l'image terminé",
      ro: 'Încărcarea imaginii completă',
      nl: 'Afbeelding uploaden voltooid',
      pl: 'Przesyłanie zdjęć zakończone',
      de: 'Bild-Upload abgeschlossen',
      es: 'Carga de imágenes completada',
    },
    subTitle: {
      en: 'Thank you for the uploads. Please proceed with the Retail App from which you scanned the QR Code, to complete the evaluation.',
      ar: 'شكرا لك على التحميلات. يرجى المتابعة مع تطبيق Retail الذي قمت من خلاله بمسح رمز الاستجابة السريعة ، لإكمال التقييم.',
      he: 'תודה לך על העלאת התמונות. אנא המשך עם אפליקציית החנות אשר מימנה סרקת את ה-QR CODE, על מנת לסיים את התהליך.',
      fr: "Merci pour les téléchargements. Veuillez poursuivre avec l'application Retail à partir de laquelle vous avez scanné le code QR pour compléter l'évaluation.",
      ro: 'Vă mulțumim pentru încărcări. Vă rugăm să continuați cu aplicația Retail din care ați scanat codul QR pentru a finaliza evaluarea.',
      nl: 'Bedankt voor de uploads. Ga verder met de Retail-app waarmee u de QR-code hebt gescand om de evaluatie te voltooien.',
      pl: 'Dziękujemy za przesłanie. Proszę kontynuować w aplikacji Retail, z której zeskanowano kod QR, aby ukończyć ocenę.',
      de: 'Danke für die Uploads. Bitte fahre mit der Retail-App fort, mit der du den QR-Code gescannt hast, um die Bewertung abzuschließen.',
      es: 'La carga de documentos se ha completado. Continúa en la aplicación de ventas donde escaneaste el código QR para completar la evaluación.',
    },
  },
  ErrorInComponentTree: {
    title: {
      en: 'Something went wrong while loading this page',
      ar: 'فشل تحميل القائمة',
      he: 'משהו השתבש...',
      fr: "Quelque chose s'est mal passé...",
      ro: 'Ceva a mers greșit...',
      nl: 'Er is iets misgegaan...',
      pl: 'Coś poszło nie tak podczas ładowania tej strony',
      de: 'Beim Laden dieser Seite ist ein Fehler aufgetreten',
      es: 'No se puede cargar esta página',
    },
    subTitle: {
      en: 'An error occurred while processing the content of this page. Try to refresh the page or contact support if the error persists.',
      ar: 'حدث خطأ أثناء معالجة محتوى هذه الصفحة. حاول تحديث الصفحة أو اتصل بالدعم إذا استمر الخطأ.',
      he: 'אירעה שגיאה בעת העלאת תוכן עמוד הדף. נסה לרענן את העמוד או פנה לתמיכה אם התקלה ממשיכה',
      fr: "Une erreur est survenue lors du traitement du contenu de cette page. Essayez de rafraîchir la page ou contactez le support si l'erreur persiste.",
      ro: 'A apărut o eroare în timpul procesării conținutului acestei pagini. Încercați să reîmprospătați pagina sau contactați suportul dacă eroarea persistă.',
      nl: 'Er is een fout opgetreden tijdens het verwerken van de inhoud van deze pagina. Probeer de pagina te vernieuwen of neem contact op met de ondersteuning als de fout aanhoudt.',
      pl: 'Wystąpił błąd podczas przetwarzania zawartości tej strony. Spróbuj odświeżyć stronę lub skontaktuj się z pomocą techniczną, jeśli błąd się utrzymuje.',
      de: 'Beim Verarbeiten des Seiteninhalts ist ein Fehler aufgetreten. Versuche die Seite zu aktualisieren oder kontaktiere den Support, wenn der Fehler weiterhin besteht.',
      es: 'Se ha producido un error al procesar el contenido de esta página. Prueba a refrescar la página o contacta con el equipo de soporte si el error persiste.',
    },
    reTry: {
      en: 'Retry',
      ar: 'استرجاع',
      he: 'נסה שוב',
      fr: 'Réessayer',
      ro: 'Încearcă din nou',
      nl: 'Opnieuw proberen',
      pl: 'Spróbuj ponownie',
      de: 'Erneut versuchen',
      es: 'Reintentar',
    },
    beginAfresh: {
      en: 'Go home?',
      ar: 'العودة إلى الصفحة الرئيسية',
      he: 'לחזור לעמוד הבית?',
      fr: "Retour à la page d'accueil ?",
      ro: 'Du-te acasă?',
      nl: 'Ga naar huis?',
      pl: 'Wrócić do strony głównej?',
      de: 'Zur Startseite?',
      es: '¿Ir al inicio?',
    },
    restartAssessment: {
      en: 'Back to the images list',
      ar: 'العودة إلى قائمة الصور',
      he: 'חזור אל רשימת התמונות',
      fr: 'Retour à la liste des images',
      ro: 'Înapoi la lista de imagini',
      nl: 'Terug naar de lijst met afbeeldingen',
      pl: 'Powrót do listy zdjęć',
      de: 'Zurück zur Bilderliste',
      es: 'Volver a la lista de imágenes',
    },
  },
  deviceListLoading: {
    title: {
      en: 'Fetching the List',
      ar: 'إحضار القائمة',
      he: 'יוצר את הרשימה',
      fr: 'Récupération de la liste',
      ro: 'Preluarea listei',
      nl: 'De lijst ophalen',
      pl: 'Pobieranie listy',
      de: 'Liste wird abgerufen',
      es: 'Obteniendo la lista',
    },
    subTitle: {
      en: 'We are retrieving the list of images required for assessment uploads. Please wait.',
      ar: 'نقوم باسترجاع قائمة الصور المطلوبة لتحميلات التقييم. انتظر من فضلك.',
      he: 'אנו מחזירים את רשימת התמונות הנדרשת לתהליך הערכת המצב. אנא המתן',
      fr: "Nous récupérons la liste des images requises pour les téléchargements d'évaluation. Veuillez patienter.",
      ro: 'Recuperăm lista de imagini necesare pentru încărcările de evaluare. Vă rugăm să așteptați.',
      nl: 'We halen de lijst met afbeeldingen op die nodig zijn voor beoordelingsuploads. Even geduld alstublieft.',
      pl: 'Pobieramy listę zdjęć wymaganych do przesłania w ramach oceny. Proszę czekać.',
      de: 'Wir rufen die Liste der Bilder für den Bewertungs-Upload ab. Bitte warten.',
      es: 'Se está recuperando la lista de imágenes necesaria para la evaluación. Espera un momento.',
    },
  },
  redirectLoading: {
    title: {
      en: 'Redirecting',
      ar: 'جارٍ التوجيه',
      he: 'מנתב מחדש',
      fr: 'Redirection',
      ro: 'Redirecționare',
      nl: 'Bezig met doorverwijzen',
      pl: 'Przekierowywanie',
      de: 'Weiterleitung',
      es: 'Redirigiendo',
    },
    subTitle: {
      en: 'We are getting the app ready. Please wait.',
      ar: 'نقوم بتحضير التطبيق. الرجاء الانتظار.',
      he: 'אנחנו מכינים את האפליקציה. אנא המתן.',
      fr: "Nous préparons l'application. Veuillez patienter.",
      ro: 'Pregătim aplicația. Vă rugăm să așteptați.',
      nl: 'We maken de app klaar. Even geduld alstublieft.',
      pl: 'Przygotowujemy aplikację. Proszę czekać.',
      de: 'Weiterleitung',
      es: 'Redirigiendo',
    },
  },
  imagePreview: {
    retake: {
      en: 'Retake',
      ar: 'إعادة',
      he: 'צלם שוב',
      fr: 'Reprendre',
      ro: 'Refa',
      nl: 'Opnieuw maken',
      pl: 'Zrób ponownie',
      de: 'Erneut aufnehmen',
      es: 'Volver a hacer la foto',
    },
    confirm: {
      en: 'Confirm',
      ar: 'يتأكد',
      he: 'אמת',
      fr: 'Confirmer',
      ro: 'Confirmă',
      nl: 'Bevestigen',
      pl: 'Potwierdź',
      de: 'Bestätigen',
      es: 'Confirmar',
    },
  },
  uploadModalContent: {
    cancel: {
      en: 'Cancel',
      ar: 'يلغي',
      he: 'בטל',
      fr: 'Annuler',
      ro: 'Anulare',
      nl: 'Annuleren',
      pl: 'Anuluj',
      de: 'Abbrechen',
      es: 'Cancelar',
    },
    uploadingImage: {
      en: 'Uploading image. Please wait.',
      ar: 'تحميل الصورة. أرجو الإنتظار.',
      he: 'מעלה תמונה, אנא המתן.',
      fr: "Téléchargement de l'image. Veuillez patienter.",
      ro: 'Se încarcă imaginea. Vă rugăm să așteptați.',
      nl: 'Afbeelding uploaden. Even geduld alstublieft.',
      pl: 'Przesyłanie zdjęcia. Proszę czekać.',
      de: 'Bild wird hochgeladen. Bitte warten.',
      es: 'Cargando imagen. Espera un momento.',
    },
    uploadImageAlt: {
      en: 'Uploading this image',
      ar: 'تحميل هذه الصورة',
      he: 'מעלה תמונה זו',
      fr: 'Téléchargement de cette image',
      ro: 'Se încarcă această imagine',
      nl: 'Deze afbeelding uploaden',
      pl: 'Przesyłanie tego zdjęcia',
      de: 'Dieses Bild wird hochgeladen',
      es: 'Subiendo esta imagen',
    },
    uploadFailed: {
      en: 'Failed to upload Image.',
      ar: 'فشل تحميل الصورة. الرجاء اعادة المحاولة.',
      he: 'העלאת התמונה נכשלה',
      fr: "Échec du téléchargement de l'image.",
      ro: 'Eșec la încărcarea imaginii.',
      nl: 'Afbeelding uploaden mislukt.',
      pl: 'Nie udało się przesłać zdjęcia.',
      de: 'Fehler beim Hochladen des Bildes.',
      es: 'No se ha podido cargar la imagen.',
    },
    imageAltText: {
      en: 'Captured image preview',
      ar: 'معاينة الصورة الملتقطة',
      he: 'תצוגה מקדימה של התמונה',
      fr: "Aperçu de l'image capturée",
      ro: 'Previzualizare imagine capturată',
      nl: 'Voorbeeld van vastgelegde afbeelding',
      pl: 'Podgląd zrobionego zdjęcia',
      de: 'Vorschau des aufgenommenen Bildes',
      es: 'Vista previa de la imagen fotografiada',
    },
    pleaseWait: {
      en: 'Please wait',
      ar: 'انتظر من فضلك',
      he: 'אנא המתן',
      fr: 'Veuillez patienter',
      ro: 'Vă rugăm să așteptați',
      nl: 'Even geduld alstublieft',
      pl: 'Proszę czekać',
      de: 'Bitte warten',
      es: 'Espera un momento',
    },
    continue: {
      en: 'Continue',
      ar: 'يكمل',
      he: 'המשך',
      fr: 'Continuer',
      ro: 'Continuă',
      nl: 'Doorgaan',
      pl: 'Kontynuuj',
      de: 'Fortfahren',
      es: 'Continuar',
    },
    retake: {
      en: 'Retake',
      ar: 'إعادة',
      he: 'צלם שוב',
      fr: 'Reprendre',
      ro: 'Refa',
      nl: 'Opnieuw maken',
      pl: 'Zrób ponownie',
      de: 'Erneut aufnehmen',
      es: 'Volver a hacer la foto',
    },
    retry: {
      en: 'Retry',
      ar: 'أعد المحاولة',
      he: 'נסה שוב',
      fr: 'Réessayer',
      ro: 'Reîncearcă',
      nl: 'Opnieuw proberen',
      pl: 'Spróbuj ponownie',
      de: 'Erneut versuchen',
      es: 'Reintentar',
    },
    uploading: {
      en: 'Uploading',
      ar: 'تحميل',
      he: 'מעלה תמונה',
      fr: 'Téléchargement',
      ro: 'Se încarcă',
      nl: 'Uploaden',
      pl: 'Przesyłanie',
      de: 'Wird hochgeladen',
      es: 'Subiendo',
    },
    failedToUpload: {
      en: 'Sorry! Failed to upload this image',
      ar: 'آسف! فشل تحميل هذه الصورة',
      he: 'אנו מתנצלים! העלאת התמונה נכשלה',
      fr: 'Désolé ! Échec du téléchargement de cette image',
      ro: 'Ne pare rău! Nu am reușit să încărcăm această imagine',
      nl: 'Sorry! Het uploaden van deze afbeelding is mislukt',
      pl: 'Przepraszamy! Nie udało się przesłać tego zdjęcia',
      de: 'Entschuldigung! Dieses Bild konnte nicht hochgeladen werden',
      es: '¡Lo sentimos! No se pudo subir esta imagen',
    },
    beginAfresh: {
      en: 'Begin afresh?',
      ar: 'نبدأ من جديد؟',
      he: 'התחל מחדש?',
      fr: 'Commencer à neuf ?',
      ro: 'Începem din nou?',
      nl: 'Opnieuw beginnen?',
      pl: 'Zacząć od nowa?',
      de: 'Von vorne beginnen?',
      es: '¿Empezar de nuevo?',
    },
    restartAssessment: {
      en: 'Restart Assessment',
      ar: 'إعادة التقييم',
      he: 'התחל הערכת מצב מחדש',
      fr: "Redémarrer l'évaluation",
      ro: 'Repornire evaluare',
      nl: 'Beoordeling herstarten',
      pl: 'Uruchom ponownie ocenę',
      de: 'Bewertung neu starten',
      es: 'Reiniciar la evaluación',
    },
  },
  assessmentDone: {
    title: {
      en: 'Swipe left with two fingers to go to the next screen and click done on the customer’s trade-in device',
      ar: 'اسحب لليسار بإصبعين للانتقال إلى الشاشة التالية وانقر على "تم" على جهاز استبدال العميل',
      he: 'החלק שמאלה עם 2 האצבעות על מנת להמשיך למסך הבא ולחץ סיים על מכשיר הלקוח',
      fr: 'Faites glisser vers la gauche avec deux doigts pour passer à l\'écran suivant et cliquez sur "Terminé" sur l\'appareil de reprise du client',
      ro: 'Glisați la stânga cu două degete pentru a trece la următorul ecran și faceți clic pe „Terminat" pe dispozitivul de schimb al clientului',
      nl: 'Veeg met twee vingers naar links om naar het volgende scherm te gaan en klik op "Gereed" op het inruilapparaat van de klant',
      pl: 'Przesuń dwoma palcami w lewo, aby przejść do następnego ekranu i kliknij gotowe na urządzeniu klienta do wymiany',
      de: 'Wischen Sie mit zwei Fingern nach links, um zum nächsten Bildschirm zu gelangen, und klicken Sie auf „Fertig" auf dem Trade-in-Gerät des Kunden',
      es: 'Desliza dos dedos hacia la izquierda para pasar a la siguiente pantalla y pulsa Hecho en el dispositivo del cliente para la recompra.',
    },
    subTitle: {
      en: 'Please press start when ready.',
      ar: 'يرجى الضغط على ابدأ عندما تكون جاهزًا.',
      he: 'אנא לחץ התחל כאשר הינך מוכן',
      fr: 'Veuillez appuyer sur démarrer lorsque vous êtes prêt.',
      ro: 'Vă rugăm să apăsați Start când sunteți gata.',
      nl: 'Druk op start wanneer u klaar bent.',
      pl: 'Proszę nacisnąć start, gdy będziesz gotowy.',
      de: 'Bitte drücken Sie auf Start, wenn Sie bereit sind.',
      es: 'Pulsa Comenzar cuando esté todo listo.',
    },
    altBtn: {
      leadingText: {
        en: "No I can't see it",
        ar: 'لا لا يمكنني رؤيته',
        he: 'לא אני לא יכול לראות זאת',
        fr: 'Non, je ne peux pas le voir',
        ro: 'Nu, nu îl pot vedea',
        nl: 'Nee, ik kan het niet zien',
        pl: 'Nie, nie widzę tego',
        de: 'Nein, ich kann es nicht sehen',
        es: 'No, no se ve',
      },
      label: {
        en: 'Restart Assessment',
        ar: 'إعادة التقييم',
        he: 'התחל הערכת מצב מחדש',
        fr: "Redémarrer l'évaluation",
        ro: 'Repornire evaluare',
        nl: 'Beoordeling herstarten',
        pl: 'Uruchom ponownie ocenę',
        de: 'Bewertung neu starten',
        es: 'Reiniciar la evaluación',
      },
    },
  },
  uploadSuccess: {
    title: {
      en: 'This image was uploaded successfully.',
      ar: 'تم تحميل هذه الصورة بنجاح.',
      he: 'תמונה זו הועלתה בהצלחה',
      fr: 'Cette image a été téléchargée avec succès.',
      ro: 'Această imagine a fost încărcată cu succes.',
      nl: 'Deze afbeelding is succesvol geüpload.',
      pl: 'To zdjęcie zostało przesłane pomyślnie.',
      de: 'Dieses Bild wurde erfolgreich hochgeladen.',
      es: 'Esta imagen se ha cargado correctamente.',
    },
  },
  assessmentConfig: {
    frontWhite: {
      intro: {
        title: {
          en: "Do you see the white screen with the QR code on the customer's trade-in device?",
          ar: 'هل ترى شاشة بيضاء بها رمز الاستجابة السريعة على جهاز استبدال العميل؟',
          he: 'האם אתה רואה את המסך הלבן עם קוד ה QR על מכשיר הלקוח?',
          fr: "Voyez-vous l'écran blanc avec le code QR sur l'appareil de reprise du client ?",
          ro: 'Vezi ecranul alb cu codul QR pe dispozitivul de schimb al clientului?',
          nl: 'Ziet u het witte scherm met de QR-code op het inruilapparaat van de klant?',
          pl: 'Czy widzisz biały ekran z kodem QR na urządzeniu klienta do wymiany?',
          de: 'Sehen Sie den weißen Bildschirm mit dem QR-Code auf dem Trade-in-Gerät des Kunden?',
          es: '¿Se puede ver la pantalla blanca con el código QR en el dispositivo del cliente para la recompra?',
        },
        ctaText: {
          en: 'Yes',
          ar: 'نعم',
          he: 'כן',
          fr: 'Oui',
          ro: 'Da',
          nl: 'Ja',
          pl: 'Tak',
          de: 'Ja',
          es: 'Sí',
        },
        subCTAPreText: {
          en: "No I can't see it",
          ar: 'لا لا يمكنني رؤيته',
          he: 'לא אני לא יכול לראות זאת',
          fr: 'Non, je ne peux pas le voir',
          ro: 'Nu, nu îl pot vedea',
          nl: 'Nee, ik kan het niet zien',
          pl: 'Nie, nie widzę tego',
          de: 'Nein, ich kann es nicht sehen',
          es: 'No, no se ve',
        },
        subCTALabelText: {
          en: 'Restart Assessment',
          ar: 'إعادة التقييم',
          he: 'התחל הערכת מצב מחדש',
          fr: "Redémarrer l'évaluation",
          ro: 'Repornire evaluare',
          nl: 'Beoordeling herstarten',
          pl: 'Uruchom ponownie ocenę',
          de: 'Bewertung neu starten',
          es: 'Reiniciar la evaluación',
        },
      },
      instructions: {
        title: {
          en: 'Capture the image of the white screen with the QR code',
          ar: 'التقط صورة الشاشة البيضاء باستخدام رمز الاستجابة السريعة',
          he: 'צלם את התמונה של המסך הלבן עם קוד ה QR',
          fr: "Capturez l'image de l'écran blanc avec le code QR",
          ro: 'Capturează imaginea ecranului alb cu codul QR',
          nl: 'Maak een foto van het witte scherm met de QR-code',
          pl: 'Zrób zdjęcie białego ekranu z kodem QR',
          de: 'Erfassen Sie das Bild des weißen Bildschirms mit dem QR-Code',
          es: 'Fotografía la pantalla en blanco con el código QR',
        },
      },
      previewAndUpload: {
        description: {
          en: '(White screen with QR)',
          ar: '(شاشة بيضاء مع رمز الاستجابة السريعة)',
          he: '(מסך לבן עם קוד QR)',
          fr: '(Écran blanc avec QR)',
          ro: '(Ecran alb cu QR)',
          nl: '(Wit scherm met QR)',
          pl: '(Biały ekran z QR)',
          de: '(Weißer Bildschirm mit QR)',
          es: '(Pantalla en blanco con QR)',
        },
        captureSuccessTitle: {
          en: 'Successfully captured the front screen',
          ar: 'تم التقاط الشاشة الأمامية بنجاح',
          he: 'המסך הראשי/קדמי צולם בהצלחה',
          fr: "L'écran avant a été capturé avec succès",
          ro: 'Ecranul frontal a fost capturat cu succes',
          nl: 'Voorscherm succesvol vastgelegd',
          pl: 'Pomyślnie uchwycono ekran przedni',
          de: 'Vorderer Bildschirm erfolgreich erfasst',
          es: 'La pantalla se ha fotografiado correctamente',
        },
        ctaText: {
          en: 'Continue',
          ar: 'يكمل',
          he: 'המשך',
          fr: 'Continuer',
          ro: 'Continuă',
          nl: 'Doorgaan',
          pl: 'Kontynuuj',
          de: 'Weiter',
          es: 'Continuar',
        },
      },
    },
    frontBlack: {
      intro: {
        title: {
          en: "Do you see the black screen with the QR code on the customer's trade-in device?",
          ar: 'هل ترى شاشة سوداء بها رمز الاستجابة السريعة على جهاز استبدال العميل؟',
          he: 'האם אתה רואה את המסך השחור עם קוד ה QR על מכשיר הלקוח?',
          fr: "Voyez-vous l'écran noir avec le code QR sur l'appareil de reprise du client ?",
          ro: 'Vezi ecranul negru cu codul QR pe dispozitivul de schimb al clientului?',
          nl: 'Ziet u het zwarte scherm met de QR-code op het inruilapparaat van de klant?',
          pl: 'Czy widzisz czarny ekran z kodem QR na urządzeniu klienta do wymiany?',
          de: 'Sehen Sie den schwarzen Bildschirm mit dem QR-Code auf dem Trade-in-Gerät des Kunden?',
          es: '¿Se puede ver la pantalla negra con el código QR en el dispositivo del cliente para la recompra?',
        },
        ctaText: {
          en: 'Yes',
          ar: 'نعم',
          he: 'כן',
          fr: 'Oui',
          ro: 'Da',
          nl: 'Ja',
          pl: 'Tak',
          de: 'Ja',
          es: 'Sí',
        },
        subCTAPreText: {
          en: "No I can't see it",
          ar: 'لا لا يمكنني رؤيته',
          he: 'לא אני לא יכול לראות זאת',
          fr: 'Non, je ne peux pas le voir',
          ro: 'Nu, nu îl pot vedea',
          nl: 'Nee, ik kan het niet zien',
          pl: 'Nie, nie widzę tego',
          de: 'Nein, ich kann es nicht sehen',
          es: 'No, no se ve',
        },
        subCTALabelText: {
          en: 'Restart Assessment',
          ar: 'إعادة التقييم',
          he: 'התחל הערכה מחדש',
          fr: "Redémarrer l'évaluation",
          ro: 'Repornire evaluare',
          nl: 'Beoordeling herstarten',
          pl: 'Uruchom ponownie ocenę',
          de: 'Bewertung neu starten',
          es: 'Reiniciar la evaluación',
        },
      },
      instructions: {
        title: {
          en: 'Capture the image of the black screen with the QR code',
          ar: 'التقط صورة الشاشة السوداء باستخدام رمز الاستجابة السريعة',
          he: 'צלם את תמונת המסך השחור עם קוד ה QR',
          fr: "Capturez l'image de l'écran noir avec le code QR",
          ro: 'Capturează imaginea ecranului negru cu codul QR',
          nl: 'Maak een foto van het zwarte scherm met de QR-code',
          pl: 'Zrób zdjęcie czarnego ekranu z kodem QR',
          de: 'Erfassen Sie das Bild des schwarzen Bildschirms mit dem QR-Code',
          es: 'Fotografía la pantalla en negro con el código QR',
        },
      },
      previewAndUpload: {
        description: {
          en: '(Black screen with QR)',
          ar: '(شاشة سوداء مع رمز الاستجابة السريعة)',
          he: '(מסך שחור עם QR)',
          fr: '(Écran noir avec QR)',
          ro: '(Ecran negru cu QR)',
          nl: '(Zwart scherm met QR)',
          pl: '(Czarny ekran z QR)',
          de: '(Schwarzer Bildschirm mit QR)',
          es: '(Pantalla en negro con QR)',
        },
        captureSuccessTitle: {
          en: 'Successfully captured the front screen',
          ar: 'تم التقاط الشاشة الأمامية بنجاح',
          he: 'המסך הראשי צולם בהצלחה',
          fr: "L'écran avant a été capturé avec succès",
          ro: 'Ecranul frontal a fost capturat cu succes',
          nl: 'Voorscherm succesvol vastgelegd',
          pl: 'Pomyślnie uchwycono czarny ekran',
          de: 'Vorderer Bildschirm erfolgreich erfasst',
          es: 'La pantalla se ha fotografiado correctamente',
        },
        ctaText: {
          en: 'Continue',
          ar: 'يكمل',
          he: 'המשך',
          fr: 'Continuer',
          ro: 'Continuă',
          nl: 'Doorgaan',
          pl: 'Kontynuuj',
          de: 'Weiter',
          es: 'Continuar',
        },
      },
      nextScreenInstructions: {
        title: {
          en: "Swipe left with two fingers to go to the next screen on the customer's trade-in device.",
          ar: 'اسحب لليسار بإصبعين للانتقال إلى الشاشة التالية على جهاز استبدال العميل.',
          he: 'החלק שמאלה עם 2 האצבעות על מנת להמשיך למסך הבא במכשיר הלקוח',
          fr: "Balayez vers la gauche avec deux doigts pour passer à l'écran suivant sur l'appareil de reprise du client.",
          ro: 'Glisați la stânga cu două degete pentru a trece la următorul ecran pe dispozitivul de schimb al clientului.',
          nl: 'Veeg met twee vingers naar links om naar het volgende scherm op het inruilapparaat van de klant te gaan.',
          pl: 'Przesuń dwoma palcami w lewo, aby przejść do następnego ekranu na urządzeniu klienta do wymiany.',
          de: 'Wischen Sie mit zwei Fingern nach links, um zum nächsten Bildschirm auf dem Trade-in-Gerät des Kunden zu gelangen.',
          es: 'Desliza dos dedos hacia la izquierda para pasar a la siguiente pantalla en el dispositivo del cliente para la recompra.',
        },
        ctaText: {
          en: 'Confirm',
          ar: 'يتأكد',
          he: 'אשר',
          fr: 'Confirmer',
          ro: 'Confirmă',
          nl: 'Bevestigen',
          pl: 'Potwierdź',
          de: 'Bestätigen',
          es: 'Confirmar',
        },
        altCtaText: {
          en: 'Restart Assessment',
          ar: 'إعادة التقييم',
          he: 'התחל הערכת מצב מחדש',
          fr: "Redémarrer l'évaluation",
          ro: 'Repornire evaluare',
          nl: 'Beoordeling herstarten',
          pl: 'Uruchom ponownie ocenę',
          de: 'Bewertung neu starten',
          es: 'Reiniciar la evaluación',
        },
      },
    },
    deviceBack: {
      intro: {
        title: {
          en: "Flip the customer's trade-in device to capture the <u><b>back</b></u> side image",
          ar: 'اقلب جهاز استبدال العميل لالتقاط صورة الجانب الخلفي',
          he: 'הפוך את מכשיר הלקוח על מנת לצלם את  <u><b>גב</b></u> המכשיר',
          fr: "Retournez l'appareil de reprise du client pour capturer l'image du côté <u><b>arrière</b></u>",
          ro: 'Răsuciți dispozitivul de schimb al clientului pentru a captura imaginea laturii <u><b>spate</b></u>',
          nl: 'Draai het inruilapparaat van de klant om om de afbeelding van de <u><b>achterkant</b></u> vast te leggen',
          pl: 'Obróć urządzenie klienta do wymiany, aby uchwycić zdjęcie <u><b>tyłu</b></u>',
          de: 'Drehen Sie das Trade-in-Gerät des Kunden um, um das Bild der <u><b>Rückseite</b></u> aufzunehmen',
          es: 'Da la vuelta al dispositivo para fotografiar la parte trasera.',
        },
        ctaText: {
          en: 'Start Capture',
          ar: 'يتأكد',
          he: 'התחל צילום',
          fr: 'Commencer la capture',
          ro: 'Începeți capturarea',
          nl: 'Start vastleggen',
          de: 'Erfassung starten',
          es: 'Comenzar a fotografiar',
        },
        subCTALabelText: {
          en: 'Restart Assessment',
          ar: 'إعادة التقييم',
          he: 'התחל מחדש הערכת מצב',
          fr: "Redémarrer l'évaluation",
          ro: 'Repornire evaluare',
          nl: 'Beoordeling herstarten',
          pl: 'Uruchom ponownie ocenę',
          de: 'Bewertung neu starten',
          es: 'Reiniciar la evaluación',
        },
      },
      instructions: {
        title: {
          en: 'Capture the backside image',
          ar: 'التقط الصورة الخلفية',
          he: 'צלם את הצד האחורי',
          fr: "Capturez l'image du côté arrière",
          ro: 'Capturați imaginea părții din spate',
          nl: 'Leg de afbeelding van de achterkant vast',
          pl: 'Zrób zdjęcie tyłu',
          de: 'Nehmen Sie das Rückseitenbild auf',
          es: 'Fotografía la parte trasera',
        },
      },
      previewAndUpload: {
        description: {
          en: '(Back of the device)',
          ar: '(الجزء الخلفي من الجهاز)',
          he: '(החלק האחורי של המכשיר)',
          fr: '(Dos de l’appareil)',
          ro: '(Partea din spate a dispozitivului)',
          nl: '(Achterkant van het apparaat)',
          de: '(Rückseite des Geräts)',
          es: '(Parte trasera del dispositivo)',
        },
        captureSuccessTitle: {
          en: 'Successfully captured the back side of the customer trade-in device',
          ar: 'تم التقاط الجانب الخلفي لجهاز مقايضة العميل بنجاح',
          he: 'החלק האחורי של מכשיר הלקוח צולם בהצלחה',
          fr: "L'image du côté arrière de l'appareil de reprise a été capturée avec succès",
          ro: 'Imaginea părții din spate a dispozitivului de schimb al clientului a fost capturată cu succes',
          nl: 'Achterkant van het inruilapparaat van de klant succesvol vastgelegd',
          pl: 'Pomyślnie uchwycono tył urządzenia klienta do wymiany',
          de: 'Rückseite des Trade-in-Geräts des Kunden erfolgreich erfasst',
          es: 'Parte trasera fotografiada correctamente.',
        },
        ctaText: {
          en: 'Continue',
          ar: 'يكمل',
          he: 'המשך',
          fr: 'Continuer',
          ro: 'Continuați',
          nl: 'Doorgaan',
          pl: 'Kontynuuj',
          de: 'Weiter',
          es: 'Continuar',
        },
      },
    },
    frontOfDeviceInfo: {
      intro: {
        title: {
          en: 'You are about to capture the <u><b>front</b></u> of the device. Make sure the device is on a clear background with the screen switched off.',
          ar: 'أنت على وشك التقاط صورة للجهة الأمامية للجهاز. تأكد من أن الجهاز على خلفية واضحة وأن الشاشة مغلقة.',
          he: 'הינך מצלם את ה <u><b>פנים</b></u> של המכשיר. שים לב שהמכשיר מונח על רקע ברור עם המסך כבוי.',
          fr: "Vous êtes sur le point de capturer l'image du <u><b>devant</b></u> de l’appareil. Assurez-vous que l’appareil est placé sur un fond clair et que l’écran est éteint.",
          ro: 'Urmează să capturezi imaginea <u><b>faței</b></u> dispozitivului. Asigură-te că dispozitivul este pe un fundal clar cu ecranul oprit.',
          nl: 'U staat op het punt de <u><b>voorkant</b></u> van het apparaat vast te leggen. Zorg ervoor dat het apparaat op een heldere achtergrond staat met het scherm uitgeschakeld.',
          pl: 'Zaraz zrobisz zdjęcie <u><b>przodu</b></u> urządzenia. Upewnij się, że urządzenie jest na jasnym tle, a ekran jest wyłączony.',
          de: 'Sie sind dabei, die <u><b>Vorderseite</b></u> des Geräts zu erfassen. Stellen Sie sicher, dass das Gerät auf einem klaren Hintergrund liegt und der Bildschirm ausgeschaltet ist.',
          es: 'Está a punto de capturar la <u><b>parte delantera</b></u> del dispositivo. Asegúrese de que el dispositivo esté sobre un fondo claro con la pantalla apagada.',
        },
        ctaText: {
          en: 'Start Capture',
          ar: 'يتأكد',
          he: ' התחל צילום',
          fr: 'Commencer la capture',
          ro: 'Începeți capturarea',
          nl: 'Start vastleggen',
          pl: 'Rozpocznij fotografowanie',
          de: 'Erfassung starten',
          es: 'Comenzar a fotografiar',
        },
        subCTALabelText: {
          en: 'Back to images list',
          ar: 'العودة إلى قائمة الصور',
          he: 'חזרה לרשימת התמונות',
          fr: 'Retour à la liste des images',
          ro: 'Înapoi la lista de imagini',
          nl: 'Terug naar de lijst met afbeeldingen',
          pl: 'Powrót do listy zdjęć',
          de: 'Zurück zur Bilderliste',
          es: 'Volver a la lista de imágenes',
        },
      },
      instructions: {
        title: {
          en: 'Capture the <u><b>front</b></u> of the device',
          ar: 'التقط الصورة الخلفية',
          he: 'צלם את <u><b>פנים</b></u> של המכשיר',
          fr: 'Capturez l’image du <u><b>devant</b></u> de l’appareil',
          ro: 'Capturează <u><b>fața</b></u> dispozitivului',
          nl: 'Leg de <u><b>voorkant</b></u> van het apparaat vast',
          pl: 'Zrób zdjęcie <u><b>przodu</b></u> urządzenia',
          de: 'Erfassen Sie die <u><b>Vorderseite</b></u> des Geräts',
          es: 'Fotografía la <u><b>parte delantera</b></u> del dispositivo',
        },
      },
      previewAndUpload: {
        description: {
          en: '(Front side of the device)',
          ar: '(الجهة الأمامية للجهاز)',
          he: '(צד הקדמי של המכשיר)',
          fr: '(Côté avant de l’appareil)',
          ro: '(Fața dispozitivului)',
          nl: '(Voorkant van het apparaat)',
          pl: '(Przód urządzenia)',
          de: '(Vorderseite des Geräts)',
          es: '(Parte delantera del dispositivo)',
        },
        captureSuccessTitle: {
          en: 'Successfully captured the <u><b>front</b></u> side of the customer trade-in device',
          ar: 'تم التقاط الجهة الأمامية لجهاز المبادلة للعميل بنجاح',
          he: 'צולם הצד <u><b>הקדמי</b></u> של מכשיר הלקוח בהצלחה.',
          fr: 'L’image du <u><b>devant</b></u> de l’appareil de reprise a été capturée avec succès',
          ro: 'Imaginea <u><b>faței</b></u> dispozitivului de schimb al clientului a fost capturată cu succes',
          nl: '<u><b>Voorkant</b></u> van het inruilapparaat van de klant succesvol vastgelegd',
          pl: 'Pomyślnie uchwycono <u><b>przód</b></u> urządzenia klienta do wymiany',
          de: '<u><b>Vorderseite</b></u> des Trade-in-Geräts des Kunden erfolgreich erfasst',
          es: 'Se capturó con éxito la <u><b>parte frontal</b></u> del dispositivo de intercambio del cliente',
        },
        ctaText: {
          en: 'Continue',
          ar: 'يكمل',
          he: 'המשך',
          fr: 'Continuer',
          ro: 'Continuați',
          nl: 'Doorgaan',
          pl: 'Kontynuuj',
          de: 'Weiter',
          es: 'Continuar',
        },
      },
    },
    frontBlackOfDeviceInfo: {
      intro: {
        title: {
          en: 'You are about to capture the <u><b>front</b></u> of the device with a <u><b>black</b></u> screen. Switch off the screen and make sure the device is on a clear background.',
          ar: 'أنت على وشك التقاط صورة للواجهة الأمامية للجهاز مع شاشة سوداء. قم بإيقاف تشغيل الشاشة وتأكد من أن الجهاز على خلفية واضحة.',
          he: 'הינך בהליך צילום של <u><b>הצד הקדמי</b></u> המכשיר עם מסך <u><b>שחור</b></u>. כבה את המסך וודא שהמכשיר נמצא על רקע ברור.',
          fr: 'Vous êtes sur le point de capturer l’image du <u><b>devant</b></u> de l’appareil avec un écran <u><b>noir</b></u>. Éteignez l’écran et assurez-vous que l’appareil est placé sur un fond clair.',
          ro: 'Urmează să capturezi <u><b>fața</b></u> dispozitivului cu un ecran <u><b>negru</b></u>. Opriți ecranul și asigurați-vă că dispozitivul este pe un fundal clar.',
          nl: 'U staat op het punt de <u><b>voorkant</b></u> van het apparaat met een <u><b>zwart</b></u> scherm vast te leggen. Schakel het scherm uit en zorg ervoor dat het apparaat op een heldere achtergrond staat.',
          pl: 'Zaraz zrobisz zdjęcie <u><b>przodu</b></u> urządzenia z <u><b>czarnym</b></u> ekranem. Wyłącz ekran i upewnij się, że urządzenie jest na jasnym tle.',
          de: 'Sie sind dabei, die <u><b>Vorderseite</b></u> des Geräts mit einem <u><b>schwarzen</b></u> Bildschirm zu erfassen. Schalten Sie den Bildschirm aus und stellen Sie sicher, dass das Gerät auf einem klaren Hintergrund liegt.',
          es: 'Está a punto de capturar la <u><b>parte delantera</b></u> del dispositivo con una pantalla <u><b>negra</b></u>. Apague la pantalla y asegúrese de que el dispositivo esté sobre un fondo claro.',
        },
        ctaText: {
          en: 'Start Capture',
          ar: 'يتأكد',
          he: 'צלם',
          fr: 'Commencer la capture',
          ro: 'Începeți capturarea',
          nl: 'Start vastleggen',
          pl: 'Rozpocznij fotografowanie',
          de: 'Erfassung starten',
          es: 'Iniciar captura',
        },
        subCTALabelText: {
          en: 'Back to images list',
          ar: 'العودة إلى قائمة الصور',
          he: 'חזרה לרשימת התמונות',
          fr: 'Retour à la liste des images',
          ro: 'Înapoi la lista de imagini',
          nl: 'Terug naar de lijst met afbeeldingen',
          pl: 'Powrót do listy zdjęć',
          de: 'Zurück zur Bilderliste',
          es: 'Volver a la lista de imágenes',
        },
      },
      instructions: {
        title: {
          en: 'Capture the <u><b>front</b></u> of the device with a <u><b>black</b></u> screen',
          ar: 'التقاط صورة للواجهة الأمامية للجهاز مع شاشة سوداء.',
          he: 'צלם את ה <u><b>מסך</b></u> של המכשיר עם מסך <u><b>שחור</b></u>.',
          fr: 'Capturez l’image du <u><b>devant</b></u> de l’appareil avec un écran <u><b>noir</b></u>.',
          ro: 'Capturează <u><b>fața</b></u> dispozitivului cu un ecran <u><b>negru</b></u>',
          nl: 'Leg de <u><b>voorkant</b></u> van het apparaat vast met een <u><b>zwart</b></u> scherm',
          pl: 'Zrób zdjęcie <u><b>przodu</b></u> urządzenia z <u><b>czarnym</b></u> ekranem',
          de: 'Erfassen Sie die <u><b>Vorderseite</b></u> des Geräts mit einem <u><b>schwarzen</b></u> Bildschirm',
          es: 'Fotografía la <u><b>parte delantera</b></u> del dispositivo con una pantalla <u><b>negra</b></u>',
        },
      },
      previewAndUpload: {
        description: {
          en: '(Front side of the device | Black Screen)',
          ar: '(الجهة الأمامية للجهاز | شاشة سوداء.)',
          he: '(צד קדמי של המכשיר| מסך שחור).',
          fr: '(Côté avant de l’appareil | Écran noir)',
          ro: '(Fața dispozitivului | Ecran negru)',
          nl: '(Voorkant van het apparaat | Zwart scherm)',
          pl: '(Przód urządzenia | Czarny ekran)',
          de: '(Vorderseite des Geräts | Schwarzer Bildschirm)',
          es: '(Parte delantera del dispositivo con la pantalla en negro)',
        },
        captureSuccessTitle: {
          en: 'Successfully captured the <u><b>front</b></u> <u><b>black</b></u> screen of the customer trade-in device',
          ar: 'تم التقاط الجهة بشاشة سوداء لجهاز المبادلة للعميل بنجاح.',
          he: 'צולם בהצלחה<u><b> החלק הקדמי </b></u> של מסך <u><b>שחור</b></u> במכשיר הלקוח.',
          fr: 'L’image du <u><b>devant</b></u> de l’appareil avec un écran <u><b>noir</b></u> a été capturée avec succès.',
          ro: 'Imaginea <u><b>faței</b></u> dispozitivului cu un ecran <u><b>negru</b></u> a fost capturată cu succes.',
          nl: '<u><b>Voorkant</b></u> <u><b>zwart</b></u> scherm van het inruilapparaat van de klant succesvol vastgelegd',
          pl: 'Pomyślnie uchwycono <u><b>przód</b></u> z <u><b>czarnym</b></u> ekranem urządzenia klienta do wymiany',
          de: '<u><b>Vorderer</b></u> <u><b>schwarzer</b></u> Bildschirm des Trade-in-Geräts des Kunden erfolgreich erfasst',
          es: 'Se capturó con éxito la pantalla <u><b>frontal</b></u> <u><b>negra</b></u> del dispositivo de intercambio del cliente',
        },
        ctaText: {
          en: 'Continue',
          ar: 'يكمل',
          he: 'המשך',
          fr: 'Continuer',
          ro: 'Continuați',
          nl: 'Durchgaan',
          pl: 'Kontynuuj',
          de: 'Weiter',
          es: 'Continuar',
        },
      },
    },
    frontWhiteOfDeviceInfo: {
      intro: {
        title: {
          en: 'You are about to capture the <u><b>front</b></u> of the device with a <u><b>white</b></u> screen. Make sure the device is on a clear background with the screen completely white and bright.',
          ar: 'أنت على وشك التقاط صورة للواجهة الأمامية للجهاز مع شاشة بيضاء. تأكد من أن الجهاز على خلفية واضحة، وأن الشاشة بيضاء تمامًا وساطعة.',
          he: 'אתה בהליך צילום של המכשיר עם <u><b>מסך</b></u>. בבקשה שימו לב כי המכשיר על רקע ברור עם ה<u><b>מסך לבן</b></u> בהיר וברור.',
          fr: 'Vous êtes sur le point de capturer l’image du <u><b>devant</b></u> de l’appareil avec un écran <u><b>blanc</b></u>. Assurez-vous que l’appareil est sur un fond clair avec l’écran entièrement blanc et lumineux.',
          ro: 'Urmează să capturezi <u><b>fața</b></u> dispozitivului cu un ecran <u><b>alb</b></u>. Asigură-te că dispozitivul este pe un fundal clar, cu ecranul complet alb și luminos.',
          nl: 'U staat op het punt de <u><b>voorkant</b></u> van het apparaat met een <u><b>wit</b></u> scherm vast te leggen. Zorg ervoor dat het apparaat op een heldere achtergrond staat met het scherm volledig wit en helder.',
          pl: 'Zaraz zrobisz zdjęcie <u><b>przodu</b></u> urządzenia z <u><b>białym</b></u> ekranem. Upewnij się, że urządzenie jest na jasnym tle, a ekran jest całkowicie biały i jasny.',
          de: 'Sie sind dabei, die <u><b>Vorderseite</b></u> des Geräts mit einem <u><b>weißen</b></u> Bildschirm zu erfassen. Stellen Sie sicher, dass das Gerät auf einem klaren Hintergrund liegt und der Bildschirm vollständig weiß und hell ist.',
          es: 'Está a punto de capturar la <u><b>parte delantera</b></u> del dispositivo con una pantalla <u><b>blanca</b></u>. Asegúrese de que el dispositivo esté sobre un fondo claro con la pantalla completamente blanca y brillante.',
        },
        ctaText: {
          en: 'Start Capture',
          ar: 'يتأكد',
          he: 'החל צילום',
          fr: 'Commencer la capture',
          ro: 'Începeți capturarea',
          nl: 'Start vastleggen',
          pl: 'Rozpocznij fotografowanie',
          de: 'Erfassung starten',
          es: 'Comenzar a fotografiar',
        },
        subCTALabelText: {
          en: 'Back to images list',
          ar: 'العودة إلى قائمة الصور',
          he: 'חזרה לרשימת התמונות',
          fr: 'Retour à la liste des images',
          ro: 'Înapoi la lista de imagini',
          nl: 'Terug naar de lijst met afbeeldingen',
          pl: 'Powrót do listy zdjęć',
          de: 'Zurück zur Bilderliste',
          es: 'Volver a la lista de imágenes',
        },
      },
      instructions: {
        title: {
          en: 'Capture the <u><b>front</b></u> of the device with a <u><b>white</b></u> screen',
          ar: 'التقاط صورة للواجهة الأمامية للجهاز مع شاشة بيضاء.',
          he: ' החל צילום <u><b>קידמת המכשיר</b></u> של המכשיר עם מסך <u><b>לבן</b></u>.',
          fr: 'Capturez l’image du <u><b>devant</b></u> de l’appareil avec un écran <u><b>blanc</b></u>.',
          ro: 'Capturează <u><b>fața</b></u> dispozitivului cu un ecran <u><b>alb</b></u>',
          nl: 'Leg de <u><b>voorkant</b></u> van het apparaat vast met een <u><b>wit</b></u> scherm',
          pl: 'Zrób zdjęcie <u><b>przodu</b></u> urządzenia z <u><b>białym</b></u> ekranem',
          de: 'Erfassen Sie die <u><b>Vorderseite</b></u> des Geräts mit einem <u><b>weißen</b></u> Bildschirm',
          es: 'Fotografía la <u><b>parte delantera</b></u> del dispositivo con una pantalla <u><b>blanca</b></u>',
        },
      },
      previewAndUpload: {
        description: {
          en: '(Front side of the device | White Screen)',
          ar: '(الجهة الأمامية للجهاز | شاشة بيضاء.)',
          he: '( צד קדמי של המכשיר | מסך לבן).',
          fr: '(Côté avant de l’appareil | Écran blanc)',
          ro: '(Fața dispozitivului | Ecran alb)',
          nl: '(Voorkant van het apparaat | Wit scherm)',
          pl: '(Przód urządzenia | Biały ekran)',
          de: '(Vorderseite des Geräts | Weißer Bildschirm)',
          es: '(Parte delantera del dispositivo con la pantalla en blanco)',
        },
        captureSuccessTitle: {
          en: 'Successfully captured the <u><b>front</b></u> <u><b>white</b></u> screen of the customer trade-in device',
          ar: 'تم التقاط الواجهة بشاشة بيضاء لجهاز المبادلة للعميل بنجاح.',
          he: 'צולם בהצלחה <u><b>מסך לבן</b></u> במכשיר של הלקוח.',
          fr: 'L’image du <u><b>devant</b></u> de l’appareil avec un écran <u><b>blanc</b></u> a été capturée avec succès.',
          ro: 'Imaginea <u><b>faței</b></u> dispozitivului cu un ecran <u><b>alb</b></u> a fost capturată cu succes.',
          nl: '<u><b>Voorkant</b></u> <u><b>wit</b></u> scherm van het inruilapparaat van de klant succesvol vastgelegd',
          pl: 'Pomyślnie uchwycono <u><b>przód</b></u> z <u><b>białym</b></u> ekranem urządzenia klienta do wymiany',
          de: '<u><b>Vorderer</b></u> <u><b>weißer</b></u> Bildschirm des Trade-in-Geräts des Kunden erfolgreich erfasst',
          es: 'Se capturó con éxito la pantalla <u><b>frontal</b></u> <u><b>blanca</b></u> del dispositivo de intercambio del cliente',
        },
        ctaText: {
          en: 'Continue',
          ar: 'يكمل',
          he: 'המשך',
          fr: 'Continuer',
          ro: 'Continuați',
          nl: 'Doorgaan',
          pl: 'Kontynuuj',
          de: 'Weiter',
          es: 'Continuar',
        },
      },
    },
    backOfDeviceInfo: {
      intro: {
        title: {
          en: 'You are about to capture the <u><b>back</b></u> of the device. Make sure the device is on a clear background.',
          ar: 'أنت على وشك التقاط صورة للجهة الخلفية للجهاز. تأكد من أن الجهاز على خلفية واضحة.',
          he: 'אתה בהליך צילום של <u><b>גב</b></u> המכשיר. שים לב שהמכשיר על רקע נקי וברור.',
          fr: 'Vous êtes sur le point de capturer l’image de l’<u><b>arrière</b></u> de l’appareil. Assurez-vous que l’appareil est sur un fond clair.',
          ro: 'Urmează să capturezi partea <u><b>din spate</b></u> a dispozitivului. Asigură-te că dispozitivul se află pe un fundal clar.',
          nl: 'U staat op het punt de <u><b>achterkant</b></u> van het apparaat vast te leggen. Zorg ervoor dat het apparaat op een heldere achtergrond staat.',
          pl: 'Zaraz zrobisz zdjęcie <u><b>tyłu</b></u> urządzenia. Upewnij się, że urządzenie jest na jasnym tle.',
          de: 'Sie sind dabei, die <u><b>Rückseite</b></u> des Geräts zu erfassen. Stellen Sie sicher, dass das Gerät auf einem klaren Hintergrund liegt.',
          es: 'Está a punto de capturar la <u><b>parte trasera</b></u> del dispositivo. Asegúrese de que el dispositivo esté sobre un fondo claro.',
        },
        ctaText: {
          en: 'Start Capture',
          ar: 'يتأكد',
          he: 'החל צילום',
          fr: 'Commencer la capture',
          ro: 'Începe captura',
          nl: 'Start vastleggen',
          pl: 'Rozpocznij fotografowanie',
          de: 'Erfassung starten',
          es: 'Comenzar a fotografiar',
        },
        subCTALabelText: {
          en: 'Back to images list',
          ar: 'العودة إلى قائمة الصور',
          he: 'חזרה לרשימת התמונות.',
          fr: 'Retour à la liste des images',
          ro: 'Înapoi la lista de imagini',
          nl: 'Terug naar de lijst met afbeeldingen',
          pl: 'Powrót do listy zdjęć',
          de: 'Zurück zur Bilderliste',
          es: 'Volver a la lista de imágenes',
        },
      },
      instructions: {
        title: {
          en: 'Capture the <u><b>back</b></u> of the device',
          ar: 'التقاط صورة للجهة الخلفية للجهاز',
          he: 'צלם את ה <u><b>גב</b></u> של המכשיר',
          fr: 'Capturez l’image de l’<u><b>arrière</b></u> de l’appareil',
          ro: 'Capturează partea <u><b>din spate</b></u> a dispozitivului',
          nl: 'Leg de <u><b>achterkant</b></u> van het apparaat vast',
          pl: 'Zrób zdjęcie <u><b>tyłu</b></u> urządzenia',
          de: 'Erfassen Sie die <u><b>Rückseite</b></u> des Geräts',
          es: 'Fotografía la <u><b>parte trasera</b></u> del dispositivo',
        },
      },
      previewAndUpload: {
        description: {
          en: '(Back side of the device)',
          ar: '(الجهة الخلفية للجهاز)',
          he: ' (החלק האחורי של המכשיר)',
          fr: '(Côté arrière de l’appareil)',
          ro: '(Partea din spate a dispozitivului)',
          nl: '(Achterkant van het apparaat)',
          pl: '(Tył urządzenia)',
          de: '(Rückseite des Geräts)',
          es: '(Parte trasera del dispositivo)',
        },
        captureSuccessTitle: {
          en: 'Successfully captured the <u><b>back</b></u> side of the customer trade-in device',
          ar: 'تم التقاط الجهة الخلفية لجهاز المبادلة للعميل بنجاح',
          he: 'הצד ה <u><b>אחורי</b></u> צולם בהצלחה במכשיר הלקוח',
          fr: 'L’image de l’<u><b>arrière</b></u> de l’appareil de reprise du client a été capturée avec succès.',
          ro: 'Partea <u><b>din spate</b></u> a dispozitivului de schimb al clientului a fost capturată cu succes.',
          nl: '<u><b>Achterkant</b></u> van het inruilapparaat van de klant succesvol vastgelegd',
          pl: 'Pomyślnie uchwycono <u><b>tył</b></u> urządzenia klienta do wymiany',
          de: '<u><b>Rückseite</b></u> des Trade-in-Geräts des Kunden erfolgreich erfasst',
          es: 'Se capturó con éxito la <u><b>parte trasera</b></u> del dispositivo de intercambio del cliente',
        },
        ctaText: {
          en: 'Continue',
          ar: 'يكمل',
          he: 'המשך',
          fr: 'Continuer',
          ro: 'Continuă',
          nl: 'Doorgaan',
          pl: 'Kontynuuj',
          de: 'Weiter',
          es: 'Continuar',
        },
      },
    },
    leftOfDeviceInfo: {
      intro: {
        title: {
          en: 'You are about to capture the <u><b>left</b></u> side of the device. Make sure the buttons, if any are clearly captured.',
          ar: 'أنت على وشك التقاط صورة للجهة اليسرى للجهاز. تأكد من أن الأزرار، إذا كانت موجودة، ملتقطة بوضوح.',
          he: 'הינך עומד לצלם את צד ה <u><b>שמאלי</b></u> במכשיר. שימו לב שהכפתורים ניתנים לתצוגה ברורה בתמונה.',
          fr: 'Vous êtes sur le point de capturer le côté <u><b>gauche</b></u> de l’appareil. Assurez-vous que les boutons, s’il y en a, sont clairement visibles.',
          ro: 'Urmează să capturezi partea <u><b>stângă</b></u> a dispozitivului. Asigură-te că butoanele, dacă există, sunt capturate clar.',
          nl: 'U staat op het punt de <u><b>linkerkant</b></u> van het apparaat vast te leggen. Zorg ervoor dat de knoppen, indien aanwezig, duidelijk worden vastgelegd.',
          pl: 'Zaraz zrobisz zdjęcie <u><b>lewej</b></u> strony urządzenia. Upewnij się, że przyciski, jeśli są, są wyraźnie widoczne.',
          de: 'Sie sind dabei, die <u><b>linke</b></u> Seite des Geräts zu erfassen. Stellen Sie sicher, dass die Tasten, falls vorhanden, deutlich erfasst werden.',
          es: 'Está a punto de capturar el lado <u><b>izquierdo</b></u> del dispositivo. Asegúrese de que los botones, si los hay, se capturen claramente.',
        },
        ctaText: {
          en: 'Start Capture',
          ar: 'يتأكد',
          he: 'החל צילום',
          fr: 'Commencer la capture',
          ro: 'Începe captura',
          nl: 'Start vastleggen',
          pl: 'Rozpocznij fotografowanie',
          de: 'Erfassung starten',
          es: 'Comenzar a fotografiar',
        },
        subCTALabelText: {
          en: 'Back to images list',
          ar: 'العودة إلى قائمة الصور',
          he: 'חזרה לרשימת התמונות',
          fr: 'Retour à la liste des images',
          ro: 'Înapoi la lista de imagini',
          nl: 'Terug naar de lijst met afbeeldingen',
          pl: 'Powrót do listy zdjęć',
          de: 'Zurück zur Bilderliste',
          es: 'Volver a la lista de imágenes',
        },
      },
      instructions: {
        title: {
          en: 'Capture the <u><b>left</b></u> side of the device',
          ar: 'التقاط صورة للجهة اليسرى للجهاز',
          he: 'צלם את החלק ה <u><b>שמאלי</b></u> בתמונה.',
          fr: 'Capturez le côté <u><b>gauche</b></u> de l’appareil',
          ro: 'Capturează partea <u><b>stângă</b></u> a dispozitivului',
          nl: 'Leg de <u><b>linkerkant</b></u> van het apparaat vast',
          pl: 'Zrób zdjęcie <u><b>lewej</b></u> strony urządzenia',
          de: 'Erfassen Sie die <u><b>linke</b></u> Seite des Geräts',
          es: 'Fotografía la lado <u><b>izquierdo</b></u> del dispositivo',
        },
      },
      previewAndUpload: {
        description: {
          en: '(Left side of the device)',
          ar: '(الجهة اليسرى للجهاز)',
          he: '(צד שמאל של המכשיר)',
          fr: '(Côté gauche de l’appareil)',
          ro: '(Partea stângă a dispozitivului)',
          nl: '(Linkerkant van het apparaat)',
          pl: '(Lewa strona urządzenia)',
          de: '(Linke Seite des Geräts)',
          es: '(Lado izquierdo del dispositivo)',
        },
        captureSuccessTitle: {
          en: 'Successfully captured the <u><b>left</b></u> side of the customer trade-in device',
          ar: 'تم التقاط الجهة اليسرى لجهاز المبادلة للعميل بنجاح',
          he: 'צולם צד <u><b>השמאלי</b></u> של המכשיר.',
          fr: 'L’image du côté <u><b>gauche</b></u> de l’appareil de reprise du client a été capturée avec succès.',
          ro: 'Partea <u><b>stângă</b></u> a dispozitivului de schimb al clientului a fost capturată cu succes.',
          nl: '<u><b>Linkerkant</b></u> van het inruilapparaat van de klant succesvol vastgelegd',
          pl: 'Pomyślnie uchwycono <u><b>lewą</b></u> stronę urządzenia klienta do wymiany',
          de: '<u><b>Linke</b></u> Seite des Trade-in-Geräts des Kunden erfolgreich erfasst',
          es: 'Se capturó con éxito el lado <u><b>izquierdo</b></u> del dispositivo de intercambio del cliente',
        },
        ctaText: {
          en: 'Continue',
          ar: 'يكمل',
          he: 'המשך',
          fr: 'Continuer',
          ro: 'Continúa',
          nl: 'Doorgaan',
          pl: 'Kontynuuj',
          de: 'Weiter',
          es: 'Continuar',
        },
      },
    },
    rightOfDeviceInfo: {
      intro: {
        title: {
          en: 'You are about to capture the <u><b>right</b></u> side of the device. Make sure the buttons, if any are clearly captured.',
          ar: 'أنت على وشك التقاط صورة للجهة اليمنى للجهاز. تأكد من أن الأزرار، إذا كانت موجودة، ملتقطة بوضوح.',
          he: 'הינך עומד לצלם את צד <u><b>הימיני</b></u> של המכשיר. שים לב',
          fr: 'Vous êtes sur le point de capturer le côté <u><b>droit</b></u> de l’appareil. Assurez-vous que les boutons, s’il y en a, sont clairement visibles.',
          ro: 'Urmărești să capturezi partea <u><b>dreapta</b></u> a dispozitivului. Asigură-te că butoanele, dacă există, sunt clar vizibile.',
          nl: 'U staat op het punt de <u><b>rechterkant</b></u> van het apparaat vast te leggen. Zorg ervoor dat de knoppen, indien aanwezig, duidelijk worden vastgelegd.',
          pl: 'Zaraz zrobisz zdjęcie <u><b>prawej</b></u> strony urządzenia. Upewnij się, że przyciski, jeśli są, są wyraźnie widoczne.',
          de: 'Sie sind dabei, die <u><b>rechte</b></u> Seite des Geräts zu erfassen. Stellen Sie sicher, dass die Tasten, falls vorhanden, deutlich erfasst werden.',
          es: 'Está a punto de capturar el lado <u><b>derecho</b></u> del dispositivo. Asegúrese de que los botones, si los hay, se capturen claramente.',
        },
        ctaText: {
          en: 'Start Capture',
          ar: 'يتأكد',
          he: 'החל צילום',
          fr: 'Commencer la capture',
          ro: 'Începe capturarea',
          nl: 'Start vastleggen',
          pl: 'Rozpocznij fotografowanie',
          de: 'Erfassung starten',
          es: 'Comenzar a fotografiar',
        },
        subCTALabelText: {
          en: 'Back to images list',
          ar: 'العودة إلى قائمة الصور',
          he: 'חזרה לרשימת הצילום',
          fr: 'Retour à la liste des images',
          ro: 'Înapoi la lista de imagini',
          nl: 'Terug naar de lijst met afbeeldingen',
          pl: 'Powrót do listy zdjęć',
          de: 'Zurück zur Bilderliste',
          es: 'Volver a la lista de imágenes',
        },
      },
      instructions: {
        title: {
          en: 'Capture the <u><b>right</b></u> side of the device',
          ar: 'التقاط صورة للجهة اليمنى للجهاز',
          he: 'צלם את צד ה <u><b>ימיני</b></u> של המכשיר.',
          fr: 'Capturez le côté <u><b>droit</b></u> de l’appareil',
          ro: 'Capturează partea <u><b>dreaptă</b></u> a dispozitivului',
          nl: 'Leg de <u><b>rechterkant</b></u> van het apparaat vast',
          pl: 'Zrób zdjęcie <u><b>prawej</b></u> strony urządzenia',
          de: 'Erfassen Sie die <u><b>rechte</b></u> Seite des Geräts',
          es: 'Fotografía la lado <u><b>derecho</b></u> del dispositivo',
        },
      },
      previewAndUpload: {
        description: {
          en: '(Right side of the device)',
          ar: '(الجهة اليمنى للجهاز)',
          he: '(צד ימין של המכשיר)',
          fr: '(Côté droit de l’appareil)',
          ro: '(Partea dreaptă a dispozitivului)',
          nl: '(Rechterkant van het apparaat)',
          pl: '(Prawa strona urządzenia)',
          de: '(Rechte Seite des Geräts)',
          es: '(Lado derecho del dispositivo)',
        },
        captureSuccessTitle: {
          en: 'Successfully captured the <u><b>right</b></u> side of the customer trade-in device',
          ar: 'تم التقاط الجهة اليمنى لجهاز المبادلة للعميل بنجاح',
          he: 'צולם בהצלחה צד <u><b>ימין</b></u> של מכשיר הלקוח.',
          fr: 'L’image du côté <u><b>droit</b></u> de l’appareil de reprise du client a été capturée avec succès.',
          ro: 'Partea <u><b>dreaptă</b></u> a dispozitivului de schimb al clientului a fost capturată cu succes.',
          nl: '<u><b>Rechterkant</b></u> van het inruilapparaat van de klant succesvol vastgelegd',
          pl: 'Pomyślnie uchwycono <u><b>prawą</b></u> stronę urządzenia klienta do wymiany',
          de: '<u><b>Rechte</b></u> Seite des Trade-in-Geräts des Kunden erfolgreich erfasst',
          es: 'Se capturó con éxito el lado <u><b>derecho</b></u> del dispositivo de intercambio del cliente',
        },
        ctaText: {
          en: 'Continue',
          ar: 'يكمل',
          he: 'המשך',
          fr: 'Continuer',
          ro: 'Continúa',
          nl: 'Doorgaan',
          pl: 'Kontynuuj',
          de: 'Weiter',
          es: 'Continuar',
        },
      },
    },
    topOfDeviceInfo: {
      intro: {
        title: {
          en: 'You are about to capture the <u><b>top</b></u> of the device. Make sure the device is on a clear background.',
          ar: 'أنت على وشك التقاط صورة للجهة العليا للجهاز. تأكد من أن الجهاز على خلفية واضحة.',
          he: 'הינך עומד לצלם את צד ה <u><b>עליון</b></u> של המכשיר. שים לב שהמכשיר נמצא על רקע ברור.',
          fr: 'Vous êtes sur le point de capturer le côté <u><b>supérieur</b></u> de l’appareil. Assurez-vous que l’appareil est sur un fond clair.',
          ro: 'Urmărești să capturezi partea <u><b>superioară</b></u> a dispozitivului. Asigură-te că dispozitivul este pe un fundal clar.',
          nl: 'U staat op het punt de <u><b>bovenkant</b></u> van het apparaat vast te leggen. Zorg ervoor dat het apparaat op een heldere achtergrond staat.',
          pl: 'Zaraz zrobisz zdjęcie <u><b>góry</b></u> urządzenia. Upewnij się, że urządzenie jest na jasnym tle.',
          de: 'Sie sind dabei, die <u><b>Oberseite</b></u> des Geräts zu erfassen. Stellen Sie sicher, dass das Gerät auf einem klaren Hintergrund liegt.',
          es: 'Está a punto de capturar la <u><b>parte superior</b></u> del dispositivo. Asegúrese de que el dispositivo esté sobre un fondo claro.',
        },
        ctaText: {
          en: 'Start Capture',
          ar: 'يتأكد',
          he: 'החל צילום',
          fr: 'Commencer la capture',
          ro: 'Începe capturarea',
          nl: 'Start vastleggen',
          pl: 'Rozpocznij fotografowanie',
          de: 'Erfassung starten',
          es: 'Comenzar a fotografiar',
        },
        subCTALabelText: {
          en: 'Back to images list',
          ar: 'العودة إلى قائمة الصور',
          he: 'חזרה לרשימת התמונות',
          fr: 'Retour à la liste des images',
          ro: 'Înapoi à la lista de imagini',
          nl: 'Terug naar de lijst met afbeeldingen',
          pl: 'Powrót do listy zdjęć',
          de: 'Zurück zur Bilderliste',
          es: 'Volver a la lista de imágenes',
        },
      },
      instructions: {
        title: {
          en: 'Capture the <u><b>top</b></u> of the device',
          ar: 'التقاط صورة للجهة العليا للجهاز',
          he: 'צלם את צד ה <u><b>עליון</b></u> של המכשיר.',
          fr: 'Capturez le côté <u><b>supérieur</b></u> de l’appareil',
          ro: 'Capturează partea <u><b>superioară</b></u> a dispozitivului',
          nl: 'Leg de <u><b>bovenkant</b></u> van het apparaat vast',
          pl: 'Zrób zdjęcie <u><b>góry</b></u> urządzenia',
          de: 'Erfassen Sie die <u><b>Oberseite</b></u> des Geräts',
          es: 'Fotografía la <u><b>parte superior</b></u> del dispositivo',
        },
      },
      previewAndUpload: {
        description: {
          en: '(Top side of the device)',
          ar: '(الجهة العليا للجهاز)',
          he: '(צד העליון של המכשיר)',
          fr: '(Côté supérieur de l’appareil)',
          ro: '(Partea superioară a dispozitivului)',
          nl: '(Bovenkant van het apparaat)',
          pl: '(Góra urządzenia)',
          de: '(Oberseite des Geräts)',
          es: '(Parte superior del dispositivo)',
        },
        captureSuccessTitle: {
          en: 'Successfully captured the <u><b>top</b></u> side of the customer trade-in device',
          ar: 'تم التقاط الجهة العليا لجهاز المبادلة للعميل بنجاح',
          he: 'צולם בהצלחה צד <u><b>top</b></u> של מכשיר הלקוח',
          fr: 'L’image du côté <u><b>supérieur</b></u> de l’appareil de reprise du client a été capturée avec succès.',
          ro: 'Partea <u><b>superioară</b></u> a dispozitivului de schimb al clientului a fost capturată cu succes.',
          nl: '<u><b>Bovenkant</b></u> van het inruilapparaat van de klant succesvol vastgelegd',
          pl: 'Pomyślnie uchwycono <u><b>górę</b></u> urządzenia klienta do wymiany',
          de: '<u><b>Oberseite</b></u> des Trade-in-Geräts des Kunden erfolgreich erfasst',
          es: 'Se capturó con éxito el lado <u><b>superior</b></u> del dispositivo de intercambio del cliente',
        },
        ctaText: {
          en: 'Continue',
          ar: 'يكمل',
          he: 'המשך',
          fr: 'Continuer',
          ro: 'Continúa',
          nl: 'Doorgaan',
          pl: 'Kontynuuj',
          de: 'Weiter',
          es: 'Continuar',
        },
      },
    },
    bottomOfDeviceInfo: {
      intro: {
        title: {
          en: 'You are about to capture the <u><b>bottom</b></u> of the device. Make sure the ports if any are clearly visible and the device is on a clear background.',
          ar: 'أنت على وشك التقاط صورة للجهة السفلية للجهاز. تأكد من أن الجهاز على خلفية واضحة.',
          he: 'אתה עומד להתחיל בהליך צילום של <u><b>תחתית</b></u> המכשיר. שים לב שכניסות המכשיר ניראות בבירור והמכשיר נמצא על רקע ברור.',
          fr: 'Vous êtes sur le point de capturer le côté <u><b>inférieur</b></u> de l’appareil. Assurez-vous que les ports, s’il y en a, sont clairement visibles et que l’appareil est sur un fond clair.',
          ro: 'Urmărești să capturezi partea <u><b>inferioară</b></u> a dispozitivului. Asigură-te că porturile, dacă există, sunt clar vizibile și că dispozitivul este pe un fundal clar.',
          nl: 'U staat op het punt de <u><b>onderkant</b></u> van het apparaat vast te leggen. Zorg ervoor dat de poorten, indien aanwezig, duidelijk zichtbaar zijn en dat ',
          pl: 'Zaraz zrobisz zdjęcie <u><b>dołu</b></u> urządzenia. Upewnij się, że porty, jeśli są, są wyraźnie widoczne i że urządzenie jest na jasnym tle.',
          de: 'Sie sind dabei, die <u><b>Unterseite</b></u> des Geräts zu erfassen. Stellen Sie sicher, dass die Anschlüsse, falls vorhanden, deutlich sichtbar sind und das Gerät auf einem klaren Hintergrund liegt.',
          es: 'Está a punto de capturar la <u><b>parte inferior</b></u> del dispositivo. Asegúrese de que los puertos, si los hay, sean claramente visibles y que el dispositivo esté sobre un fondo claro.',
        },
        ctaText: {
          en: 'Start Capture',
          ar: 'يتأكد',
          he: 'החל צילום',
          fr: 'Commencer la capture',
          ro: 'Începe captura',
          nl: 'Start vastleggen',
          pl: 'Rozpocznij fotografowanie',
          de: 'Erfassung starten',
          es: 'Comenzar a fotografiar',
        },
        subCTALabelText: {
          en: 'Back to images list',
          ar: 'العودة إلى قائمة الصور',
          he: 'חזרה לרשימת התמונות',
          fr: 'Retour à la liste des images',
          ro: 'Înapoi la lista de imagini',
          nl: 'Terug naar de lijst met afbeeldingen',
          pl: 'Powrót do listy zdjęć',
          de: 'Zurück zur Bilderliste',
          es: 'Volver a la lista de imágenes',
        },
      },
      instructions: {
        title: {
          en: 'Capture the <u><b>bottom</b></u> of the device',
          ar: 'التقاط صورة للجهة السفلية للجهاز',
          he: 'צלם את ה <u><b>תחתית</b></u> של המכשיר',
          fr: 'Capturez le côté <u><b>inférieur</b></u> de l’appareil',
          ro: 'Capturează partea <u><b>inferioară</b></u> a dispozitivului',
          nl: 'Leg de <u><b>onderkant</b></u> van het apparaat vast',
          pl: 'Zrób zdjęcie <u><b>dołu</b></u> urządzenia',
          de: 'Erfassen Sie die <u><b>Unterseite</b></u> des Geräts',
          es: 'Fotografía la <u><b>parte inferior</b></u> del dispositivo',
        },
      },
      previewAndUpload: {
        description: {
          en: '(Bottom side of the device)',
          ar: '(الجهة السفلية للجهاز)',
          he: '(החלק התחתון של המכשיר)',
          fr: '(Côté inférieur de l’appareil)',
          ro: '(Partea inferioară a dispozitivului)',
          nl: '(Onderkant van het apparaat)',
          pl: '(Dół urządzenia)',
          de: '(Unterseite des Geräts)',
          es: '(Parte inferior del dispositivo)',
        },
        captureSuccessTitle: {
          en: 'Successfully captured the <u><b>bottom</b></u> side of the customer trade-in device',
          ar: 'تم التقاط الجهة السفلية لجهاز المبادلة للعميل بنجاح',
          he: 'צולם בהצלחה צד <u><b>bottom</b></u> של מכשיר הלקוח',
          fr: 'L’image du côté <u><b>inférieur</b></u> de l’appareil de reprise du client a été capturée avec succès.',
          ro: 'Partea <u><b>inferioară</b></u> a dispozitivului de schimb al clientului a fost capturată cu succes.',
          nl: '<u><b>Onderkant</b></u> van het inruilapparaat van de klant succesvol vastgelegd',
          pl: 'Pomyślnie uchwycono <u><b>dół</b></u> urządzenia klienta do wymiany',
          de: '<u><b>Unterseite</b></u> des Trade-in-Geräts des Kunden erfolgreich erfasst',
          es: 'Se capturó con éxito el lado <u><b>inferior</b></u> del dispositivo de intercambio del cliente',
        },
        ctaText: {
          en: 'Continue',
          ar: 'يكمل',
          he: 'המשך',
          fr: 'Continuer',
          ro: 'Continúa',
          nl: 'Doorgaan',
          pl: 'Kontynuuj',
          de: 'Weiter',
          es: 'Continuar',
        },
      },
    },
  },
};
